// Configuración del cliente OIDC (Keycloak).
//
// Sustituye a aws-exports.js. La diferencia de fondo no es el proveedor: con
// Cognito la app implementaba el alta, la verificación por correo, la
// recuperación y el enlace de cuentas sociales —775 líneas en Login.js—. Aquí
// todo eso lo sirve Keycloak en sus propias páginas y la app sólo redirige.
//
// Los valores por defecto apuntan al realm de PalletCloud. Son públicos: el
// client_id de un cliente OIDC público no es un secreto, por eso no lleva
// client_secret y usa PKCE.

const issuer = process.env.REACT_APP_OIDC_ISSUER
    || 'https://auth.palletcloud.io/realms/palletcloud';

export const oidcConfig = {
    authority: issuer,
    client_id: process.env.REACT_APP_OIDC_CLIENT_ID || 'palletcloud-web',

    // A dónde vuelve Keycloak tras autenticar. Tiene que estar dado de alta en
    // los redirectUris del cliente, si no Keycloak rechaza la petición.
    redirect_uri: window.location.origin + '/',
    post_logout_redirect_uri: window.location.origin + '/',

    response_type: 'code',
    scope: 'openid email profile',

    // PKCE. Sin esto el cliente responde "Missing parameter:
    // code_challenge_method": está configurado como obligatorio en Keycloak.
    // oidc-client-ts lo genera por petición.
    disablePKCE: false,

    // Renueva el token en segundo plano antes de que expire, sin sacar al
    // usuario. Antes esto lo hacía fetchAuthSession en cada llamada.
    automaticSilentRenew: true,

    // Limpia el ?code= y el ?state= de la barra de direcciones al volver.
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
};

export const ISSUER = issuer;

// Lleva directo al formulario de registro de Keycloak.
//
// Antes esto se hacia con extraQueryParams: { prompt: 'create' }, que es
// estandar de OIDC y Keycloak entiende. El problema es que Keycloak REENVIA el
// prompt al proveedor de identidad: si desde el registro el usuario elegia
// Google, Google recibia prompt=create, que no es uno de sus valores validos
// (none, consent, select_account) y respondia
//
//     Error 400: invalid_request - Invalid prompt: create
//
// Keycloak publica el registro en su propio endpoint, que acepta exactamente
// los mismos parametros que /auth. Apuntando ahi no hay ningun prompt que
// reenviar, asi que el boton de Google del formulario vuelve a funcionar.
export const ENDPOINT_REGISTRO =
    issuer + '/protocol/openid-connect/registrations';

